<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12 m-b-10" v-if="getRoleType === 99 || getRoleType === 30">
        <router-link :to="{
          name: 'MenuSettingRuleStoreCopyView',
          params: {
            brand_id: $route.params.brand_id
          }
        }">
          <div class="btn btn-default">
            返回菜單同步權限設定
          </div>
        </router-link>
      </div>

      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="form-inline">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table
                    v-if="list"
                    class="table table-bordered table-striped"
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>帳號名稱</th>
                        <th>時間</th>
                        <th>門市（新增、移除、結果）</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in list" :key="list.id">
                        <td class="w-xs">{{ i + 1 }}</td>
                        <td class="w-sm">{{ item.manager_account }}</td>
                        <td class="w-md">{{ moment(item.action_time).format('YYYY/MM/DD HH:mm:ss') }}</td>
                        <td class="w-auto">
                          <div class="mb-1">新增：{{ handleName(item.action.add) }}</div>
                          <div class="mb-1">移除：{{ handleName(item.action.remove) }}</div>
                          <div>結果：{{ handleName(item.action.result) }}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'

import matcherModal from '@/components/elements/Modal'
import moment from 'moment'

export default {
  name: 'MenuSettingRuleStoreCopyLogs',
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      black: {
        option: {
          id: 'editModal',
          title: '黑名單設定',
          btns: [
            {
              name: '取消'
            },
            {
              name: '確定',
              event: 'update'
            }
          ]
        },
        temp: []
      },
      list: []
    }
  },
  methods: {
    getList () {
      const brandId = this.$route.params.brand_id
      const url = `/brand/${brandId}/storeMenuCopySetting/history`
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          const newList = res.data.list.map((i) => {
            let temp = i
            temp.action.add = this.handleList(i.action.add)
            temp.action.remove = this.handleList(i.action.remove)
            temp.action.result = this.handleList(i.action.result)
            return temp
          })
          this.list = newList
        }
      })
    },
    handleName (list = []) {
      const temp = list.map((i) => i.name)
      return temp.join('、') || '無'
    },
    handleList (list = []) {
      return list.map((i) => {
        let temp = {
          id: i.id,
          name: i.name
        }
        if (!i.name) {
          temp.name = `[${i.id}][無門市名稱]`
        }
        return temp
      })
    },
    moment: moment
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>

<style lang="scss" scoped>
.w-xs {
  width: 40px;
}
.w-sm {
  width: 130px;
}
.w-md {
  width: 170px;
}
.w-auto {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// MenuSettingRuleStoreCopyLogs.vue?591beae0